import React, { Component } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';

// NOTE: CONVENTION
// <AvatarButton
    // className='class-name-here'
    // onClick={function for onClick}
    // id='id-name-here'
    // ref={ref stuff here}
    // value='Value of the button' // NOTE: If there is one
    // isLoading='true/false/loading value'
    // disabled='true/false/loading/disabled' // NOTE: This also uses loading value if there is a loading value present
    // message='message to show on the button' />
// NOTE: isLoading activates spinner on press

class AvatarButton extends Component {
  render() {
    return(
      <button
        className={this.props.className}
        id={this.props.id}
        onClick={this.props.onClick}
        value={this.props.value}
        ref={this.props.ref}
        disabled={(this.props.disabled || this.props.isLoading)}
        style={{color: this.props.isLoading ? 'transparent' : 'white', position: 'relative'}}
        >
        <CircularProgress id='response-spinner' size={23} thickness={4} style={{position: 'absolute', color: this.props.isLoading ? 'white' : 'transparent', left: '50%', top: '50%', transform: 'translateX(-50%) translateY(-50%)'}}/>
        {this.props.message}
      </button>
    )
  }
}

export default AvatarButton;
